const deepgramLanguages = {
  es: 'Spanish',
  en: 'English',
  hi: 'Hindi',
  ja: 'Japanese',
  ru: 'Russian',
  uk: 'Ukrainian',
  sv: 'Swedish',
  zh: 'Chinese',
  pt: 'Portuguese',
  nl: 'Dutch',
  tr: 'Turkish',
  fr: 'French',
  de: 'German',
  id: 'Indonesian',
  ko: 'Korean',
  it: 'Italian',
};

const extendedLanguages = {
  ...deepgramLanguages,
  hy: 'Armenian',
  ar: 'Arabic',
  bn: 'Bengali',
  da: 'Danish',
  el: 'Greek',
  he: 'Hebrew',
  hu: 'Hungarian',
  no: 'Norwegian',
  pl: 'Polish',
  ro: 'Romanian',
  th: 'Thai',
  vi: 'Vietnamese',
  ms: 'Malay',
  fa: 'Persian',
  fi: 'Finnish',
  hr: 'Croatian',
  cs: 'Czech',
  sk: 'Slovak',
  sl: 'Slovenian',
  sr: 'Serbian',
  ta: 'Tamil',
  te: 'Telugu',
  mr: 'Marathi',
  ur: 'Urdu',
  bg: 'Bulgarian',
  lt: 'Lithuanian',
  lv: 'Latvian',
  et: 'Estonian',
};

/**
 * Gets display names for given language codes.
 * Handles regional variants by using only the base language code.
 *
 * @param {string[]} languageCodes - An array of language codes.
 * @returns {string[]} An array of display names for the given language codes.
 */
const getLanguageDisplayNames = (languageCodes = []) => {
  return languageCodes
    .map(code => {
      const baseCode = code.split('-')[0];
      return extendedLanguages[baseCode];
    })
    .filter(Boolean);
};

export default getLanguageDisplayNames;
